import { useTranslation } from 'react-i18next'
import React, { useEffect, useMemo } from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'

import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text, { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import InputWithInterpolations from '../../../../../../packages/kiti-editor/components/input/InputWithInterpolations'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'
import { useInterpolations } from '../../../../../../utils/interpolations/interpolations'

const UpdateServiceOrderNameSentence = () => {
  const { t } = useTranslation(['triggers', 'common'])
  const [open, setOpen] = React.useState()
  const { form } = useFormState()
  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolations = useInterpolations(form.entity, checklistId)

  const selectedChecklist = useMemo(() => {
    return form?.conditions?.find(condition => {
      return (
        (condition.field === 'service_order.checklist_id' || condition.field === 'checklist_id') && !!condition.value
      )
    })
  }, [form.conditions])

  const dataToChange = () => {
    if (form.payload.content) {
      if (form.payload.content.includes('{{')) {
        return t('triggers:dynamicFields')
      }
      return form.payload.content
    }
    return '_______'
  }

  return (
    <>
      <Text size="h2">{'com '}</Text>
      <EditableSentence label={dataToChange()} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Title size="h5" bold>
          {t('triggers:actions.update_service_order_name')}
        </Title>
        <Separator weight={4} />

        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem
              label={t('triggers:content')}
              path={['payload', 'content']}
              Input={selectedChecklist ? InputWithInterpolations : null}
              interpolations={interpolations}
              singleLine
            />
          </Col>
        </Grid>
        <SubmitBar label={t('common:save')} onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default UpdateServiceOrderNameSentence
